module.exports = __webpack_public_path__ + "static/media/3.bfdcb7e7.jpg";